module.exports = __webpack_public_path__ + "static/media/resource-pdf.87db14ae.svg";